import ajax from "./ajax";

export function requestPricings() {
  return ajax("/pricing/plans");
}

export function upgradePlan(data) {
  return ajax("/pricing/upgrade", { method: "POST", data, server: "python" });
}

export function confirmSubscription(data) {
  return ajax("/shopify/confirm-subscription", {
    method: "POST",
    data,
    server: "python",
  });
}

// ── Settings → Billing page ────────────────────────────────────────────────
// Plan/usage meters (company stores, seller storefronts, users, orders/month).
export function requestPlanUsage() {
  return ajax("/counts/plan-usage");
}

// Plan, subscription, canonical-customer card, invoices, upcoming, fees.
export function requestBillingSummary() {
  return ajax("/pricing/billing-summary", { server: "python" });
}

// Attach/update the card on the canonical platform customer.
export function savePlatformPaymentMethod(data) {
  return ajax("/pricing/payment-method", {
    method: "POST",
    data,
    server: "python",
  });
}

export function cancelSubscription() {
  return ajax("/pricing/cancel-subscription", {
    method: "POST",
    server: "python",
  });
}
